import Stream from '../libs/Stream';


let destroyOrderItemActionStream: Stream<any> = new Stream() as Stream<any>;

export default destroyOrderItemActionStream;
